import React from 'react'

import './compact-model-list.scss'

import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
  }
>

const CompactModelList = ({className, children, ...props}: Props) => (
  <div {...props} className={cn('CompactModelList', {}, className)}>
    {mapChildrenWithFragments(children)}
  </div>
)

export default CompactModelList
